import { render, staticRenderFns } from "./verifications.vue?vue&type=template&id=25d3894a&scoped=true"
import script from "./verifications.vue?vue&type=script&lang=js"
export * from "./verifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d3894a",
  null
  
)

export default component.exports